import React from 'react';
import styled, {css} from 'styled-components';
import __ from '../utils/translator'
import themeResponsiveProperty from './responsive/themeResponsiveProperty';

export default ({ percentage, ...rest }) => (
  <Container {...rest}>
    <span>{__('Completed: :percentage%', { percentage: parseInt(percentage, 10) })}</span>
    <Bar>
      <Total />
      <Completed width={percentage} />
    </Bar>
  </Container>
);

const Container = styled.div`
  color: #fff;
`;

const Bar = styled.div`
  position: relative;
  height: .25rem; // 4px
  margin-top: .5rem;
`;

const Total = styled.div`
  position: absolute;
  top: .0625rem; // 1px
  left: 0;
  right: 0;
  width: ${themeResponsiveProperty(null, '100%')};
  height: .125rem; // 2px
  background-color: rgba(170,170,170,.5);
`;

const Completed = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: ${({ width }) => width}%;
  height: .25rem; // 4px
  background-color: #fff;
  border-radius: 0 .125rem .125rem 0;
`;
